/**
 * @module app.ext.iccc
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IAssessmentsConfig } from 'app/core/models/essette-interfaces';
import { AssessmentService } from 'app/core/services/assessment-service';


@autoinject()
export class Assessment extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected attachmentId: string | null = null;
    protected hasIcccAccess: boolean = false;

    protected assessmentConfig: IAssessmentsConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
        backRouteName: 'cm.case.assessments'
    };


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly service: AssessmentService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: { caseId: string, attachmentId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params.attachmentId) { throw new Error("Invalid or missing parameter [attachmentId]"); }

        this.service.configure(this.assessmentConfig);
        this.attachmentId = params.attachmentId;

        this.checkPermissions();
    }


    ////****************** Events ***************************************************////

    protected async navigateBack(): Promise<void> {
        this.router.navigateBack();
    }


    ////****************** Functions ************************************************////

    private async checkPermissions(): Promise<void> {
        this.hasIcccAccess = this.env.config.integrations.includes('iccc');
    }


    ////****************** Service Calls ********************************************////

}
